import { useMutation } from '@apollo/react-hooks';
import { DELETE_ENTITY } from '../../graphql/entity/mutation';
import {
  DeleteEntity,
  DeleteEntityVariables,
} from '../../graphql/entity/types/DeleteEntity';

export const useDeleteEntity = () => {
  return useMutation<DeleteEntity, DeleteEntityVariables>(DELETE_ENTITY, {
    onError: (error) => console.log('delete entity error ', error),
  });
};
